// store/bulkSelectSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedLeads: {}, // Object instead of Map
};

const bulkSelectSlice = createSlice({
  name: "bulkSelect",
  initialState,
  reducers: {
    setSelectedLeads: (state, action) => {
      state.selectedLeads = action.payload;
    },
    addLead: (state, action) => {
      state.selectedLeads[action.payload._id] = action.payload;
    },
    removeLead: (state, action) => {
      delete state.selectedLeads[action.payload];
    },
    clearAll: (state) => {
      state.selectedLeads = {};
    },
    clearCurrentPage: (state, action) => {
      action.payload.forEach((leadId) => {
        delete state.selectedLeads[leadId];
      });
    },
  },
});

export const {
  setSelectedLeads,
  addLead,
  removeLead,
  clearAll,
  clearCurrentPage,
} = bulkSelectSlice.actions;
export default bulkSelectSlice.reducer;